import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { StyledImage } from "~/components/article/article-image/styles";
import { ArticleSponsor } from "~/components/article/article-sponsor";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}

  position: relative;

  block-size: calc(100vh - 60px);

  overflow: hidden;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 750px;
  }
`;

export const BackgroundImageContainer = styled.div`
  z-index: -1;

  ${StyledImage} {
    ${setFullViewportWidthStyles()}

    block-size: 750px;

    object-fit: cover;
    object-position: 50% 50%;
  }
`;

export const BackgroundImageDesktopContainer = styled.div`
  display: none;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const BackgroundImageDesktop = styled.img`
  inline-size: 100%;
  block-size: 750px;

  object-fit: cover;
  object-position: 50% 50%;
`;

export const BackgroundImageMobile = styled.img`
  display: block;

  inline-size: 100%;
  block-size: calc(100vh - 60px);
  min-block-size: 750px;

  object-fit: cover;
  object-position: 50% 50%;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const Content = styled.div`
  ${setFullViewportWidthStyles()}

  position: absolute;
  inset-block-start: 0;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: center;

  block-size: 100%;

  background: rgba(0, 0, 0, 0.4);
`;

export const Headline = styled.div`
  inline-size: 300px;
  margin-block: 160px 32px;

  color: #ffffff;
  font-weight: 900;
  font-size: 32px;
  font-family: ${fontRoboto};
  line-height: 38px;
  text-align: center;

  ::before {
    content: " ";

    display: block;

    inline-size: 44px;
    block-size: 6px;
    margin-block: 0 8px;
    margin-inline: auto;

    background-color: #ffffff;

    ${props => props.theme.breakpoints.up("tablet")} {
      margin-block: 0 28px;
    }
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 502px;
    margin-block: 160px 40px;

    font-size: 40px;
    line-height: 52px;
  }
`;

export const StyledArticleSponsor = styled(ArticleSponsor)``;

export const PaidPostMessage = styled.div`
  margin-inline: auto;

  color: #ffffff;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
`;

export const PaidPostName = styled.div`
  margin-block-start: 4px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
`;
